// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tab-like-plus-loading .ant-spin .ant-spin-dot-item {
  background-color: var(--color-detached) !important;
}
`, "",{"version":3,"sources":["webpack://./src/Assets/styles/default/pages/likePlus/LikePlusPageStyles.less"],"names":[],"mappings":"AAGA;EAEQ,kDAAA;AAHR","sourcesContent":["// DESKTOP\n.like-plus-page-wrapper {}\n\n.tab-like-plus-loading {\n    .ant-spin .ant-spin-dot-item {\n        background-color: var(--color-detached) !important;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
